export const roles = {
    Spc: "SPC",
    Admin: "Admin",
    Training: "Training",
    Recruitment: "Recruiter",
    PlanningMobilisation: "PlanningMobilisation",
    HR: "HR",
    Manager: "Manager",
    Maintenance: "Maintenance",
    Talent: "Talent",
    Reports: "Reports",
}

export const roleDisplayNames = {
    [roles.Spc]: "Roster Read Only",
    [roles.Admin]: "Admin",
    [roles.Training]: "Training",
    [roles.Recruitment]: "Recruitment Team",
    [roles.PlanningMobilisation]: "Planning & Mobilisation",
    [roles.HR]: "HR",
    [roles.Manager]: "Manager",
    [roles.Maintenance]: "Maintenance",
    [roles.Talent]: "Talent",
    [roles.Reports]: "Reports",
}